import React from 'react';
import styled from "styled-components";

function Hamburger({isOpen}) {

    return (

        <HamburgerStyle>
            <div
                className="burger burger1"
                style={{transform: isOpen ? 'rotate(45deg' : 'rotate(0)'}}
            ></div>
            <div
                className="burger burger2"
                style={{
                    transform: isOpen ? 'translateX(100%)' : 'translateX(0)',
                    opacity: isOpen ? '0' : '1'
            }}

            ></div>
            <div
                className="burger burger3"
                style={{
                    transform: isOpen ? 'rotate(-45deg)' : 'rotate(0)'
                }}


            ></div>
        </HamburgerStyle>

    )
        ;
}

export default Hamburger;

const HamburgerStyle = styled.div`

  width: 2rem;
  height: 2rem;
  margin-right: 10px;
  margin-top: -10px;
  display: flex;
  justify-content: space-around;
  flex-flow: column nowrap;
  z-index: 10;
  


  .burger {
    width: 2rem;
    height: 0.25rem;
    border-radius: 10px;
    background-color: var(--mainTextColor);
    transform-origin: 1px;
    transition: all 0.3s linear;
    

  }




`;